document.addEventListener("DOMContentLoaded", function () {
  const overlayElement = document.querySelector("[data-site-overlay]");

  document.querySelectorAll(".size_guide_popup_trigger").forEach((trigger) => {
    trigger.addEventListener("click", function (event) {
      event.preventDefault();

      const productId = this.dataset.sizeGuideId;
      const popup = document.querySelector(
        `[data-size-guide-popup="${productId}"]`,
      );
      console.log(productId)
      console.log('popup',popup )
      if (!popup) return;

      openSizeGuidePopup(popup, overlayElement);
    });
  });

  document.querySelectorAll(".size-guide_popup_close").forEach((closeBtn) => {
    closeBtn.addEventListener("click", function (event) {
      event.preventDefault();

      const popup = this.closest(".size-guide_popup");
      if (!popup) return;

      closeSizeGuidePopup(popup, overlayElement);
    });
  });

  document.querySelectorAll(".size_guide_nav_item").forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();

      const popup = this.closest(".size-guide_popup");
      if (!popup) return;

      const unitSystem = this.classList.contains("imperial")
        ? "imperial"
        : "metric";

      changeSizeGuideTab(popup, unitSystem);
    });
  });
});

function openSizeGuidePopup(popup, overlayElement) {
  popup.style.display = "block";
  overlayElement?.classList.add("show");
  document.body.classList.add("body-hidden");
}

function closeSizeGuidePopup(popup, overlayElement) {
  popup.style.display = "none";
  overlayElement?.classList.remove("show");
  document.body.classList.remove("body-hidden");
}

function changeSizeGuideTab(popup, name) {
  if (!name) return;

  popup.querySelectorAll(".size_guide_table").forEach((item) => {
    item.classList.remove("active");
  });

  popup.querySelectorAll(".size_guide_nav_item").forEach((item) => {
    item.classList.remove("active");
  });

  popup.querySelector(`.size_guide_table_${name}`)?.classList.add("active");
  popup.querySelector(`.size_guide_nav_item.${name}`)?.classList.add("active");
}
